let snapshot = { revision: -1, announcement: null };
const listeners = new Set();
const notify = () => listeners.forEach(listener => listener());

function receiveSiteAnnouncement(data) {
  if (!Number.isSafeInteger(data?.revision) || data.revision <= snapshot.revision) return;
  const a = data.announcement;
  if (a !== null && (!a || typeof a.id !== 'string' || typeof a.title !== 'string' || typeof a.message !== 'string'
    || !Number.isFinite(Date.parse(a.startsAt)) || !Number.isFinite(Date.parse(a.expiresAt)))) return;
  snapshot = { revision: data.revision, announcement: a };
  notify();
}
function matchesAudience(audience, isPlus) {
  if (audience === 'plus') return !!isPlus;
  if (audience === 'free') return !isPlus;
  return true;
}
function visibleAnnouncement(state, dismissedId, now = Date.now(), { isPlus } = {}) {
  const a = state.announcement;
  return a && a.id !== dismissedId && Date.parse(a.startsAt) <= now && now < Date.parse(a.expiresAt)
    && matchesAudience(a.audience, isPlus) ? a : null;
}
const subscribe = listener => { listeners.add(listener); return () => listeners.delete(listener); };
const getSnapshot = () => snapshot;
module.exports = { receiveSiteAnnouncement, visibleAnnouncement, subscribe, getSnapshot };
